exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vti__flag{margin-right:8px}.vue-tel-input-vuetify{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.vue-tel-input-vuetify .country-code{width:75px}.vue-tel-input-vuetify li.last-preferred{border-bottom:1px solid #cacaca}.vue-tel-input-vuetify .v-text-field .v-select__selections{position:relative}.vue-tel-input-vuetify .v-text-field .v-select__selections .vti__flag{position:absolute;margin-left:18px}.vue-tel-input-vuetify .v-text-field--outlined .v-select__selections .vti__flag{margin-left:auto}", ""]);

// exports
